import * as Yup from 'yup';

const changePinSchema = Yup.object({
  pin: Yup.string()
    .matches(/^\d{4,8}$/, 'PIN must be 4-8 digits')
    .required('Current PIN is required'),
  newPin: Yup.string()
    .matches(/^\d{4,8}$/, 'PIN must be 4-8 digits')
    .required('New PIN is required'),
});

export default changePinSchema;
